export default {
    url: '',
    template: '<quiz form-submission="vm.formSubmission"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            // TODO :: consider reducing shown fields, all fields should not be seen by another person
            return FormSubmissionResource.get({
                guid: $stateParams.guid,
                expand: 'form,occurrenceTraining,trainingActiveI18n,user.company',
                fallbackLanguage: $stateParams.fallbackLanguage
            }).$promise;
        },
        company (CompanyResource, formSubmission) {
            return CompanyResource.publicView({ id: formSubmission.companyId }).$promise;
        }
    },
    controller ($state, formSubmission, FORMS_SUBMISSION_STATUS_ENUM, WindowConfirmService, CompanyService, company) {
        if (company.skin) {
            CompanyService.loadSkin(company.skin);
        }

        this.formSubmission = formSubmission;
        if (formSubmission.status === FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
            $state.go('quiz.finished', { guid: formSubmission.guid });
        }

        // ask confirmation if user refresh
        WindowConfirmService.activate();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/quiz/do/index.js